(function ($) {
    /*
     * Rotater slider
     */
    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);

    var xDown = null;
    var yDown = null;

    function getTouches(evt) {
        return evt.touches || evt.originalEvent.touches;
    }

    function handleTouchStart(evt) {
        const firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    };

    function handleTouchMove(evt) {
        if (!xDown || !yDown) {
            return;
        }
        var xUp = evt.touches[0].clientX;
        var yUp = evt.touches[0].clientY;

        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0) {
                nextswipe();

            } else {
                prevswipe();
            }
        }
        /* reset values */
        xDown = null;
        yDown = null;
    };

    function nextswipe() {
        var index = $('.company-slider .generic-rotate-slider .slide.active').index() + 1;
        var length = $('.company-slider .generic-rotate-slider .nav .button').length;
        $('.company-slider .generic-rotate-slider .nav .button').removeClass("color").addClass('active');
        $('.company-slider .generic-rotate-slider .nav .button:eq(' + index + ')').addClass("color").removeClass('active');
        var lastIndex = 0;
        var prevlastIndex = 0;
        var prevIndex = 0;
        var nextIndex = 0;

        if(length > 3){
            if ((index + 1) === length) {
                nextIndex = 0;
            } else {
                nextIndex = index + 1;
            }
            prevIndex = index - 1;

            if (length > 4) {
                prevlastIndex = index + 3;
                if (prevlastIndex > (length - 1)) {
                    var i = prevlastIndex - (length - 1);
                    prevlastIndex = 0 + (i - 1);
                }
            }


            lastIndex = index + 2;
            if (lastIndex > (length - 1)) {
                var i = lastIndex - (length - 1);
                lastIndex = 0 + (i - 1);
            }

            $('.generic-rotate-slider').find('.carousel-element .slide').removeClass('active p-active n-active l-active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + index + ')').addClass('active').removeClass('p-active n-active pl-active l-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + nextIndex + ')').addClass('n-active').removeClass('p-active active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevIndex + ')').addClass('p-active').removeClass('active n-active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + lastIndex + ')').addClass('l-active').removeClass('active n-active p-active pl-active');
            if (index >= 4) {
                $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevlastIndex + ')').addClass('pl-active').removeClass('active n-active p-active l-active');

                $('.generic-rotate-slider').find('.carousel-element .slide:eq(0)').addClass('active').removeClass('p-active n-active pl-active l-active');
                $('.generic-rotate-slider').find('.carousel-element .slide:eq(1)').addClass('n-active').removeClass('p-active active pl-active');
                $('.company-slider .generic-rotate-slider .nav .button:eq(0)').addClass("color").removeClass('active');
            }
        }
        else{
            if ((index + 1) === length) {
                nextIndex = 0;
            } else {
                nextIndex = index + 1;
            }
            prevIndex = index - 1;

            if (length > 3) {
                prevlastIndex = index + 2;
                if (prevlastIndex > (length - 1)) {
                    var i = prevlastIndex - (length - 1);
                    prevlastIndex = 0 + (i - 1);
                }
            }


            lastIndex = index + 1;
            if (lastIndex > (length - 1)) {
                var i = lastIndex - (length - 1);
                lastIndex = 0 + (i - 1);
            }

            $('.generic-rotate-slider').find('.carousel-element .slide').removeClass('active p-active n-active l-active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + index + ')').addClass('active').removeClass('p-active n-active pl-active l-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + nextIndex + ')').addClass('l-active').removeClass('p-active active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevIndex + ')').addClass('p-active').removeClass('active n-active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + lastIndex + ')').addClass('n-active').removeClass('active l-active p-active pl-active');
            if (index >= 3) {
                $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevlastIndex + ')').addClass('pl-active').removeClass('active n-active p-active l-active');

                $('.generic-rotate-slider').find('.carousel-element .slide:eq(0)').addClass('active').removeClass('p-active n-active pl-active l-active');
                $('.generic-rotate-slider').find('.carousel-element .slide:eq(1)').addClass('n-active').removeClass('p-active active pl-active');
                $('.company-slider .generic-rotate-slider .nav .button:eq(0)').addClass("color").removeClass('active');
            }
        }

    }


    function prevswipe() {
        var index = $('.company-slider .generic-rotate-slider .slide.active').index() - 1;
        var length = $('.company-slider .generic-rotate-slider .nav .button').length;
        $('.company-slider .generic-rotate-slider .nav .button').removeClass("color").addClass('active');
        $('.company-slider .generic-rotate-slider .nav .button:eq(' + index + ')').addClass("color").removeClass('active');
        var lastIndex = 0;
        var prevlastIndex = 0;
        var prevIndex = 0;
        var nextIndex = 0;

        if(length > 3){
            if ((index + 1) === length) {
                nextIndex = 0;
            } else {
                nextIndex = index + 1;
            }
            prevIndex = index - 1;

            if (length > 4) {
                prevlastIndex = index + 3;
                if (prevlastIndex > (length - 1)) {
                    var i = prevlastIndex - (length - 1);
                    prevlastIndex = 0 + (i - 1);
                }
            }


            lastIndex = index + 2;
            if (lastIndex > (length - 1)) {
                var i = lastIndex - (length - 1);
                lastIndex = 0 + (i - 1);
            }

            $('.generic-rotate-slider').find('.carousel-element .slide').removeClass('active p-active n-active l-active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + index + ')').addClass('active').removeClass('p-active n-active pl-active l-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + nextIndex + ')').addClass('n-active').removeClass('p-active active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevIndex + ')').addClass('p-active').removeClass('active n-active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + lastIndex + ')').addClass('l-active').removeClass('active n-active p-active pl-active');
            if (index >= 4) {
                $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevlastIndex + ')').addClass('pl-active').removeClass('active n-active p-active l-active');

                $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + length - 1 + ')').addClass('active').removeClass('p-active n-active pl-active l-active');
                $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + length - 2 + ')').addClass('n-active').removeClass('p-active l-active active pl-active');
                $('.company-slider .generic-rotate-slider .nav .button:eq(' + length - 1 + ')').addClass("color").removeClass('active');
            }
        }
        else{
            if ((index - 1) === 0) {
                nextIndex = length - 1;
            } else {
                nextIndex = index + 1;
            }
            prevIndex = index - 1;

            if (length > 3) {
                prevlastIndex = index + 2;
                if (prevlastIndex > (length - 1)) {
                    var i = prevlastIndex - (length - 1);
                    prevlastIndex = 0 + (i - 1);
                }
            }


            lastIndex = index + 1;
            if (lastIndex > (length - 1)) {
                var i = lastIndex - (length - 1);
                lastIndex = 0 + (i - 1);
            }

            $('.generic-rotate-slider').find('.carousel-element .slide').removeClass('active p-active n-active l-active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + index + ')').addClass('active').removeClass('p-active n-active pl-active l-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + nextIndex + ')').addClass('l-active').removeClass('p-active active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevIndex + ')').addClass('p-active').removeClass('active n-active pl-active');
            $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + lastIndex + ')').addClass('n-active').removeClass('active l-active p-active pl-active');
            if (index >= 4) {
                $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevlastIndex + ')').addClass('pl-active').removeClass('active n-active p-active l-active');

                $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + length - 1 + ')').addClass('active').removeClass('p-active n-active pl-active l-active');
                $('.generic-rotate-slider').find('.carousel-element .slide:eq(' + length - 2 + ')').addClass('n-active').removeClass('p-active active pl-active');
                $('.company-slider .generic-rotate-slider .nav .button:eq(' + length - 1 + ')').addClass("color").removeClass('active');
            }
        }
    }

    $(document).ready(function () {
        var length = $('.company-slider .generic-rotate-slider .nav .button').length;
        $('.company-slider .generic-rotate-slider .slide:eq(2)').addClass('p-active');
        $('.company-slider .generic-rotate-slider .slide:eq(0)').addClass('active');
        $('.company-slider .generic-rotate-slider .slide:eq(1)').addClass('n-active');
        if(length > 3){
            $('.company-slider .generic-rotate-slider .slide:eq(3)').addClass('l-active');
        }
        if (length > 4) {
            $('.company-slider .generic-rotate-slider .slide:eq(4)').addClass('pl-active');
        }

        $('.company-slider .generic-rotate-slider .nav .button:eq(0) ').addClass('color active');

        $('.company-slider .generic-rotate-slider .slide:eq(0)').addClass('active');

        $('.company-slider .generic-rotate-slider .nav .button.active').click(function () {
            $('.company-slider .generic-rotate-slider .nav .button.color').removeClass('color');
            $(this).removeClass("active");
            $(this).addClass("color");
        });
    });

    getHeight();
    $(".company-slider .generic-rotate-slider .slide").css('height', maxHeight + 'px');

    $(window).on('resize', function () {
        getHeight();
        $(".company-slider .generic-rotate-slider .slide").css('height', maxHeight + 'px');

    }).resize();

    function getHeight() {
        var heights = $(".company-slider .generic-rotate-slider .slide").map(function () {
            return $(this).height();
        }).get();

        maxHeight = Math.max.apply(null, heights);
    }

    var items = $('.company-slider .generic-rotate-slider .nav .button').click(function () {
        var index = items.index(this);
        var previousIndex = $('.company-slider .generic-rotate-slider .nav .button.color').index();
        var length = $('.company-slider .generic-rotate-slider .nav .button').length;
        $('.company-slider .generic-rotate-slider .nav .button').removeClass("color").addClass('active');
        $('.company-slider .generic-rotate-slider .nav .button:eq(' + index + ')').addClass("color").removeClass('active');
        var lastIndex = 0;
        var prevlastIndex = 0;
        var prevIndex = 0;
        var nextIndex = 0;
        var $this = $(this);
        if ((index + 1) === length) {
            nextIndex = 0;
        } else {
            nextIndex = index + 1;
        }
        prevIndex = index - 1;

        if (length > 4) {
            prevlastIndex = index + 3;
            if (prevlastIndex > (length - 1)) {
                var i = prevlastIndex - (length - 1);
                prevlastIndex = 0 + (i - 1);
            }
        }


        lastIndex = index + 2;
        if (lastIndex > (length - 1)) {
            var i = lastIndex - (length - 1);
            lastIndex = 0 + (i - 1);
        }
        if (index < previousIndex) {
            $this.parents('.generic-rotate-slider').find('.carousel-element .slide').removeClass('active');
            $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + index + ')').addClass('active').removeClass('p-active n-active pl-active l-active');
            setTimeout(function () {
                $this.parents('.generic-rotate-slider').find('.carousel-element .slide').not($this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + index + ')')).removeClass('active p-active n-active l-active pl-active');
                $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + nextIndex + ')').addClass('n-active').removeClass('p-active active pl-active');
                $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevIndex + ')').addClass('p-active').removeClass('active n-active pl-active');

            if(length > 3){
                $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + lastIndex + ')').addClass('l-active').removeClass('active n-active p-active pl-active');
            }
            if (length > 4) {
                $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevlastIndex + ')').addClass('pl-active').removeClass('active n-active p-active l-active');
            }
            }, 50);
        } else {
            $this.parents('.generic-rotate-slider').find('.carousel-element .slide').removeClass('active p-active n-active l-active pl-active');
            $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + index + ')').addClass('active').removeClass('p-active n-active pl-active l-active');
            $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + nextIndex + ')').addClass('n-active').removeClass('p-active active pl-active');
            $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevIndex + ')').addClass('p-active').removeClass('active n-active pl-active');
           if (length > 3){
               $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + lastIndex + ')').addClass('l-active').removeClass('active n-active p-active pl-active');
           }
            if (length > 4) {
                $this.parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevlastIndex + ')').addClass('pl-active').removeClass('active n-active p-active l-active');
            }
        }
    });


    var slide = $('.company-slider .generic-rotate-slider .carousel-element .slide').click(function () {
        var index = slide.index(this);
        var length = $('.company-slider .generic-rotate-slider .nav .button').length;
        $('.company-slider .generic-rotate-slider .nav .button').removeClass("color").addClass('active');
        $('.company-slider .generic-rotate-slider .nav .button:eq(' + index + ')').addClass("color").removeClass('active');
        var lastIndex = 0;
        var prevlastIndex = 0;
        var prevIndex = 0;
        var nextIndex = 0;

        if ((index + 1) === length) {
            nextIndex = 0;
        } else {
            nextIndex = index + 1;
        }
        prevIndex = index - 1;

        if (length > 4) {
            prevlastIndex = index + 3;
            if (prevlastIndex > (length - 1)) {
                var i = prevlastIndex - (length - 1);
                prevlastIndex = 0 + (i - 1);
            }
        }


        lastIndex = index + 2;
        if (lastIndex > (length - 1)) {
            var i = lastIndex - (length - 1);
            lastIndex = 0 + (i - 1);
        }
        $(this).parents('.generic-rotate-slider').find('.carousel-element .slide').removeClass('active p-active n-active l-active pl-active');
        $(this).parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + index + ')').addClass('active').removeClass('p-active n-active pl-active l-active');
        $(this).parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + nextIndex + ')').addClass('n-active').removeClass('p-active active pl-active');
        $(this).parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevIndex + ')').addClass('p-active').removeClass('active n-active pl-active');
       if(length > 3){
           $(this).parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + lastIndex + ')').addClass('l-active').removeClass('active n-active p-active pl-active');
       }
        if (length > 4) {
            $(this).parents('.generic-rotate-slider').find('.carousel-element .slide:eq(' + prevlastIndex + ')').addClass('pl-active').removeClass('active n-active p-active l-active');
        }

    });


})(jQuery);